import { useAuth0 } from '@auth0/auth0-react'
import styled from '@emotion/styled'
import { formatTime, formatDateMMDDYYYY } from '../../lib/time'
import { ChevronRight } from '@mui/icons-material'
import {
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
  Pagination,
  Paper,
  Switch,
  SwitchProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
  Popper,
  Grow,
  ClickAwayListener,
  MenuList,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  FilterIconDark,
  PlusIcon,
  ResetIcon,
  SearchIconSM,
} from '../../assets/icons/icons'
import { Fetching } from '../../components/Fetching'
import { useFilterProjects, useMutateDeleteProject } from './hooks'
import SnackBarContext from '../../context/SnackBarContext'
import { useGetInfo } from '../dashboard/hooks'
import { useGetUserAccount } from '../userManagement/hooks'

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName='.Mui-focusVisible' disableRipple {...props} />
))(({ theme }: { theme: any }) => ({
  width: 38,
  height: 22,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor:
          theme.palette.mode === 'dark' ? '#2ECA45' : theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 18,
    height: 18,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

const serialize = (obj: any) => {
  var str = []
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
    }
  return str.join('&')
}

export const Projects = () => {
  const [search, setSearch] = useState('')
  const [tempSearch, setTempSearch] = useState('')
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)

  const [strParam, setStrParam] = useState('')
  const { data: projects,refetch, isFetching: isFetchingProjects } = useFilterProjects(
    'projects',
    strParam
  )
  const [authUser, setAuthUser] = useState<any | undefined>()
  const { isLoading, user } = useAuth0()
  const [userRoles, setUserRoles] = useState<
    'vtadmin' | 'superintendent' | 'worker' | null
  >(null)
  const navigate = useNavigate()
  const now = Date.now()
  const theme = useTheme()
  let [selectedTimesheets, setSelectedTimesheets] = useState({})
  let [filterParam, setFilterParam] = useState('')
  const [openLimit, setOpenLimit] = useState<null | HTMLElement>(null)

  useEffect(() => {
    setStrParam(
      '?' +
        serialize({
          pageSize: limit,
          search: tempSearch,
          page,
        })
    )
  }, [limit, search, tempSearch, page])

  useEffect(() => {
    setPage(1)
  }, [tempSearch])

  useEffect(() => {
    if (user) {
      setAuthUser(user)
      setUserRoles(user[`${process.env.REACT_APP_WEB_URL}/roles`])
    }
  }, [user])
  useEffect(()=>{
  refetch()
  },[strParam])

  const handlePageChange = (newPage: number) => {
    setPage(newPage)
  }
  if (isLoading) {
    return <Fetching />
  }

  return (
    <>
      <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
        <Box
          marginBottom={3}
          alignItems={'center'}
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'space-between'}>
          <Typography variant='h4'>Projects</Typography>
       {userRoles?.includes('superintendent')?"":   <Button
            variant='contained'
            sx={{
              padding: theme.spacing(1.5, 4, 1.5, 4),
              borderRadius: '8px',
              textTransform: 'capitalize',
              fontSize: '13px',
            }}
            onClick={() => navigate('/projects/new')}>
            <PlusIcon /> <Box sx={{ width: 10 }} /> Create Project
          </Button>}
        </Box>

        {/* Main Table */}
        <Card
          sx={{
            padding: 1,
            boxShadow: 'none',
            border: '1px solid #EEEEEE',
            borderRadius: '10px',
          }}>
          <CardHeader
            sx={{
              marginBottom: 0,
              paddingBottom: 0,
              paddingTop: '10px !important',
            }}
          />
          <CardContent
            sx={{
              paddingBottom: '15px !important',
              paddingTop: 0,
            }}>
            <ProjectsTable
              setPage={() => {}}
              setSelectedTimesheets={setSelectedTimesheets}
              param={`${filterParam}limit=${limit}&page=${page}&search${search}`}
              projects={projects?.data}
              search={search}
              tempSearch={tempSearch}
              setTempSearch={setTempSearch}
              setSearch={setSearch}
            />
            <Box
              alignItems={'center'}
              display={'flex'}
              justifyContent={'space-between'}
              mt={2}>
              <Button
                id='basic-button-1'
                aria-controls={Boolean(openLimit) ? 'basic-menu-1' : undefined}
                aria-haspopup='true'
                aria-expanded={Boolean(openLimit) ? 'true' : undefined}
                onClick={(event: any) => setOpenLimit(event.currentTarget)}
                sx={{
                  border: '1px solid #DEE2E0',
                  color: 'black',
                  fontWeight: '400',
                  padding: '5px',
                  borderRadius: '10px',
                }}
                endIcon={
                  <ChevronRight
                    sx={{ transform: 'rotate(90deg)', color: '#5A525B' }}
                  />
                }>
                {limit}
              </Button>
              <Menu
                id='basic-menu-1'
                anchorEl={openLimit}
                open={Boolean(openLimit)}
                onClose={() => setOpenLimit(null)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button-1',
                }}
                sx={{
                  boxShadow: 'none',
                  '& .MuiPaper-root': {
                    boxShadow:
                      '0px 5px 12px 0px #0000000A, 0px 22px 22px 0px #00000008, 0px 49px 30px 0px #00000005, 0px 88px 35px 0px #00000003, 0px 137px 38px 0px #00000000',
                    borderRadius: '10px',
                    border: '1px solid #F1EFF5',
                  },
                  '& ul': {
                    padding: '7px 0px',
                    // backgroundColor: 'red',
                    boxShadow: 'none',
                  },
                  '& li:hover': {
                    backgroundColor: 'transparent',
                  },
                  '& li': {
                    margin: '5px 10px',
                    borderBottom: '1px solid #DEE2E0',
                    textAlign: 'left',
                    padding: '5px 0',
                    fontSize: 14,
                    color: '#5F5C5F',
                  },
                  '& li:last-child': {
                    border: 'none !important',
                  },
                  marginTop: 1,
                }}>
                {[10, 20, 30].map(item => (
                  <MenuItem
                    sx={{
                      width: 48,
                      textAlign: 'center',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    onClick={() => {
                      setOpenLimit(null)
                      setLimit(item)
                    }}>
                    {item}
                  </MenuItem>
                ))}
              </Menu>

              <Pagination
                count={projects?.totalPages || 1}
                onChange={(event, page) => {
                  setPage(page)
                }}
                color='primary'
              />
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Backdrop
        sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
        open={!tempSearch && isFetchingProjects}>
        <CircularProgress color='inherit' />
      </Backdrop>
    </>
  )
}
interface Row {
  _id: string
}
interface CheckedItems {
  [key: string]: boolean
}
const ProjectsTable = ({
  param,
  projects,
  setPage,
  setSelectedTimesheets,
  tempSearch,
  setTempSearch,
  setSearch,
}: {
  param: any
  setPage: any
  projects: any
  setSelectedTimesheets: any
  search: string
  setTempSearch: any
  tempSearch: any
  setSearch: any
}) => {
  const [checkedItems, setCheckedItems] = useState<CheckedItems>({})
  const [selectedRowId, setSelectedRowId] = useState<string[]>([])
  const [expandedRows, setExpandedRows] = useState<string[]>([])
  const [isChecked, setIsChecked] = useState(false)
  const navigate = useNavigate()
  const theme = useTheme()
  const [open, setOpen] = React.useState(false)
  const {toggleSnackbar}=useContext(SnackBarContext)
  const { user } = useAuth0()
  const { data: _ } = useGetInfo('profile', user?.sub)
  const { data: userData, isFetching } = useGetUserAccount('user', _?.id)

  const [openDialog, setOpenDialog] = React.useState(false)
  const anchorRef = React.useRef<HTMLButtonElement>(null)
  const mutation = useMutateDeleteProject('projects');
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }
  const handleClose = (event: Event | React.SyntheticEvent) => {
    if (
      anchorRef.current &&
      anchorRef.current.contains(event.target as HTMLElement)
    ) {
      return
    }
    setOpen(false)
  }

  useEffect(() => {
    setPage(1)
  }, [param, setPage])

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    row: Row
  ) => {
    const isChecked = e.target.checked
    const newCheckedItems: CheckedItems = {
      ...checkedItems,
      [row._id]: isChecked,
    }
    setCheckedItems(newCheckedItems)
    if (isChecked) {
      setSelectedRowId(prevSelectedRowIds => [...prevSelectedRowIds, row._id])
      setIsChecked(false)
    } else {
      setIsChecked(false)
      setSelectedRowId(prevSelectedRowIds =>
        prevSelectedRowIds.filter(id => id !== row._id)
      )
      setExpandedRows(prevExpandedRows =>
        prevExpandedRows.filter(id => id !== row._id)
      )
    }
  }
  const checkedRowIds = Object.keys(checkedItems).filter(
    key => checkedItems[key]
  )
  const handleExpandRow = (rowIds: string[] | null): void => {
    setIsChecked(prevChecked => !prevChecked)
    if (rowIds !== null) {
      const newExpandedRows = [...expandedRows]

      rowIds.forEach(rowId => {
        const isRowExpanded: boolean = newExpandedRows.includes(rowId)
        if (isRowExpanded) {
          const index = newExpandedRows.indexOf(rowId)
          if (index > -1) {
            newExpandedRows.splice(index, 1)
          }
        } else {
          newExpandedRows.push(rowId)
        }
      })

      setExpandedRows(newExpandedRows)
    }
  }

  const handleResetFilter = () => {
    setTempSearch('')
    setSearch('')
  }

  const handleDeleteProject = async () => {
    const projectsToDelete = Object.keys(checkedItems).filter(
      (key) => checkedItems[key]
    );
  
    if (projectsToDelete.length === 0) {
      console.log("No projects selected for deletion.");
      return;
    }
  
    try {
      for (const projectId of projectsToDelete) {
        await mutation.mutateAsync(projectId);
        toggleSnackbar(`Project deleted successfully.`,"success");
      }
      // Clear the checked items after successful deletion
      setCheckedItems({});
      setOpen(false);
      setOpenDialog(false)
    } catch (error) {
      console.error("Error deleting projects:", error);
    }
  };
  

  return (
    <>
      <TableContainer
        component={Paper}
        sx={{ boxShadow: 'none', minHeight: '61vh', overflowY: 'auto' }}>
        <Box
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            display: 'flex',
            marginBottom: 2,
          }}>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            flexDirection={'row'}>
            <Box
              sx={{
                border: '2px solid #D7D4DE',
                padding: '0px 10px',
                borderRadius: '10px',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
              }}>
              <SearchIconSM />
              <TextField
                id='standard-basic'
                label=''
                variant='standard'
                placeholder='Search by name, client or location'
                value={tempSearch}
                onChange={(e: any) => {
                  const value = e.target.value;
                  if (value.length === 1 && value === ' ') {
                    e.preventDefault();
                    return;
                  }
                  setTempSearch(value);
                }}
                sx={{
                  paddingLeft: 1,
                  border: 'none !important',
                  width: '30vw',
                  outline: 'none',
                  '& input': {
                    fontSize: '16px',
                    // fontFamily: "Buenos Aires",
                  },
                  '& div::after, & div::before, div:hover:not(.Mui-disabled, .Mui-error):before':
                    {
                      borderBottom: '0px solid black',
                    },
                }}
              />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row', width: '300px' }}>
              <Button
                variant='contained'
                sx={{
                  backgroundColor: '#E5E3E9',
                  boxShadow: 'none',
                  padding: theme.spacing(0.8, 3, 0.8, 3),
                  borderRadius: '8px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  color: 'black',
                  fontWeight: '400',
                  marginLeft: 2,
                  minWidth: '64px',
                  marginRight: 1,
                  '&:hover': {
                    backgroundColor: '#E5E3E9',
                    boxShadow: 'none',
                  },
                }}
                onClick={() => {
                  setSearch(tempSearch)
                }}>
                <FilterIconDark /> <Box sx={{ width: 10 }} /> Filter
              </Button>
              <Button
                variant='contained'
                sx={{
                  backgroundColor: '#E5E3E9',
                  boxShadow: 'none',
                  padding: theme.spacing(0.8, 3, 0.8, 3),
                  borderRadius: '8px',
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  minWidth: '64px',
                  color: 'black',
                  fontWeight: '400',
                  '&:hover': {
                    backgroundColor: '#E5E3E9',
                    boxShadow: 'none',
                  },
                }}
                onClick={handleResetFilter}>
                <ResetIcon colorBg /> <Box sx={{ width: 5 }} /> Reset Filter
              </Button>
            </Box>
          </Box>

          <Box>
            <FormControlLabel
              control={
                <IOSSwitch
                  disabled={checkedRowIds.length === 0}
                  sx={{ m: 1 }}
                  theme={theme}
                  name='showDetailsSwitch'
                  checked={isChecked}
                  onChange={() => handleExpandRow(checkedRowIds)}
                />
              }
              label={
                <span style={{ color: checkedRowIds.length === 0 ? 'black' : 'black' }}>
                  Show details
                </span>
              }
            />

            <Button
              ref={anchorRef}
              id='composition-button'
              aria-controls={open ? 'composition-menu' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup='true'
              onClick={handleToggle}
              disabled={checkedRowIds.length === 0 || userData?.type == "superintendent"}
              sx={{
                backgroundColor: '#EEEEEE',
                border: '1px solid #DEE2E0',
                color: 'black',
                fontWeight: '400',
                padding: '5px 15px',
                borderRadius: '10px',
                marginLeft: 1,
                textTransform: 'capitalize',
              }}
              endIcon={
                <ChevronRight
                  sx={{ transform: 'rotate(90deg)', color: '#5A525B' }}
                />
              }>
              Bulk Actions
            </Button>
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              placement='bottom-start'
              transition
              disablePortal>
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === 'bottom-start' ? 'left top' : 'left bottom',
                  }}>
                  <Paper
                    sx={{
                      marginTop: 1,
                      boxShadow:
                        '0px 5px 12px 0px #0000000A, 0px 22px 22px 0px #00000008, 0px 49px 30px 0px #00000005, 0px 88px 35px 0px #00000003, 0px 137px 38px 0px #00000000',
                      borderRadius: '10px',
                      border: '1px solid #F1EFF5',
                    }}>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        autoFocusItem={open}
                        id='composition-menu'
                        aria-labelledby='composition-button'>
                        {['Delete Projects'].map(item => (
                          <MenuItem onClick={()=>setOpenDialog(true)}>{item}</MenuItem> 
                        ))}
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            <Dialog
                open={openDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Delete Confirmation"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this project?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={()=>setOpenDialog(false)}
                     sx={{"&:hover": {backgroundColor: "#f0f0f0",}}}>
                     Cancel
                    </Button>
                    <Button 
                        onClick={() => {
                              handleDeleteProject()
                              setOpen(false)
                        }}
                        autoFocus
                       sx={{"&:hover": {backgroundColor: "#f0f0f0",}}}          
                     >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
          </Box>
        </Box>
        <Table
          sx={{
            minWidth: 650,
            boxShadow: 'none',
          }}
          aria-label='simple table'>
          <TableHead sx={{}}>
            <TableRow
              sx={{
                color: '#E8E0E8',
                '& th': {
                  backgroundColor: '#24212C',
                  padding: '7px',
                  color: 'white',
                  fontWeight: 400,
                  whiteSpace: 'nowrap',
                },
                '& th:first-child': {
                  // alignItems: 'center',
                  // display: 'flex',
                  borderRadius: '10px 0px 0px 10px',
                },
                '& th:last-child': {
                  borderRadius: '0px 10px 10px 0px',
                },
              }}>
              <TableCell>
                <Box
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    alignItems: 'center',
                  }}>
                  <Checkbox
                    checked={(projects || []).every(
                      (row: any) => checkedItems[row?._id] === true
                    )}
                    onChange={(e: any) => {
                      const isCheckedALL = e.target.checked
                      const newCheckedItems: { [key: string]: boolean } = {}
                      const newSelectedTimesheets: { [key: string]: any } = {}
                      ;(projects || []).forEach((row: any) => {
                        newCheckedItems[row._id] = isCheckedALL
                        if (isCheckedALL) {
                          newSelectedTimesheets[row._id] = row
                        }
                      })
                      setCheckedItems(newCheckedItems)
                      setSelectedTimesheets(newSelectedTimesheets)
                    }}
                    sx={{ color: 'white', fill: 'white' }}
                  />
                  PROJECT NAME
                </Box>
              </TableCell>
              <TableCell>PROJECT NO</TableCell>
              <TableCell>CLIENT</TableCell>
              <TableCell>LOCATION</TableCell>
              <TableCell>ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              '& td': {
                backgroundColor: 'white',
                color: '#5F5C5F',
                fontWeight: 400,
                whiteSpace: 'nowrap',
                padding: '15px 0px',
                fontSize: 14,
              },
              '& td:first-child': {
                borderRadius: '10px 0px 0px 10px',
              },
              '& td:last-child': {
                borderRadius: '0px 10px 10px 0px',
              },
            }}>
            {(projects || [])?.map((row: any, index: any) => (
              <>
                <TableRow
                  key={index}
                  // onClick={() => {
                  //   navigate(row.id);
                  // }}
                  sx={{
                    // cursor: "pointer",
                    '& td, & th': {
                      border: 0,
                      background: index % 2 == 0 ? 'white' : '#F1EFF5',
                      padding: '7px',
                    },
                    '& *': {
                      color: '#5F5C5F',
                    },
                    '& svg, & svg path': {
                      color: !checkedItems[row?._id] ? '#5F5C5F' : '#F0845D',
                    },
                  }}>
                  <TableCell scope='row'>
                    <Box
                      style={{
                        flexDirection: 'row',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left',
                      }}>
                      <Checkbox
                        checked={checkedItems[row?._id] || false}
                        onChange={e => handleCheckboxChange(e, row)}
                        sx={{ color: 'red !important', fill: 'white' }}
                      />
                      {row?.projectName}
                    </Box>
                  </TableCell>
                  <TableCell>{row?.projectNumber}</TableCell>
                  <TableCell>{row?.clientName}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        minWidth: '300px',
                        width: '100%',
                        maxHeight: '100px',
                        height: '100%',
                        overflowX: 'auto !important',
                      }}>
                      {row?.locations?.map((item: any) => {
                        return (
                          <>
                            {item?.address}
                            <br />
                          </>
                        )
                      })}
                    </Box>
                  </TableCell>
                  <TableCell style={{}}>
                    <ProjectMenu project={row} />
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0 }}
                    colSpan={6}>
                    <Collapse
                      in={expandedRows.includes(row._id)}
                      timeout='auto'
                      unmountOnExit>
                      <Box
                        sx={{
                          boxShadow: 'none',
                          backgroundColor: '#f9f9f9',
                          padding: 2,
                        }}>
                        <Typography variant='h6' gutterBottom component='div'>
                          {row.projectName}
                        </Typography>

                        <Table size='small' aria-label='purchases'>
                          <TableHead>
                            <TableRow>
                              <TableCell>Project Number</TableCell>
                              <TableCell>Project Description</TableCell>
                              <TableCell>Project DueDate</TableCell>
                              <TableCell> Client Name</TableCell>
                              <TableCell sx={{paddingRight:"100px"}}>Client Emails</TableCell>
                              <TableCell>Daily StartTime</TableCell>
                              <TableCell>Daily EndTime</TableCell>
                              <TableCell>Lunch Duration</TableCell>
                              <TableCell>Address</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow>
                              <TableCell>{row.projectNumber}</TableCell>
                              <TableCell>{row.projectDescription}</TableCell>
                              <TableCell>
                                {formatDateMMDDYYYY(row.projectDueDate)}
                              </TableCell>
                              <TableCell>{row.clientName}</TableCell>
                              <TableCell>{row.clientEmails}</TableCell>
                              <TableCell>
                                {formatTime(row.dailyStartTime)}
                              </TableCell>
                              <TableCell>
                                {formatTime(row.dailyEndTime)}
                              </TableCell>
                              <TableCell>{row.lunchDuration}</TableCell>
                              <TableCell>
                                {row?.locations?.map((item: any) => (
                                  <>
                                    {item?.address}
                                    <br />
                                  </>
                                ))}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </Box>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  )
}

const ProjectMenu = ({ project }: any) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const navigate = useNavigate()
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <Box
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          display: 'flex',
          paddingLeft: 3,
          cursor: 'pointer',
        }}>
        <IconButton
          sx={{ width: 35, height: 35 }}
          onClick={(event: any) => {
            setAnchorEl(event.currentTarget)
          }}>
          <svg
            width='16'
            height='6'
            viewBox='0 0 16 6'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M0 3.00065C0 3.57529 0.228273 4.12639 0.634602 4.53272C1.04093 4.93904 1.59203 5.16732 2.16667 5.16732C2.7413 5.16732 3.2924 4.93904 3.69873 4.53272C4.10506 4.12639 4.33333 3.57529 4.33333 3.00065C4.33333 2.42602 4.10506 1.87492 3.69873 1.46859C3.2924 1.06226 2.7413 0.833984 2.16667 0.833984C1.59203 0.833984 1.04093 1.06226 0.634602 1.46859C0.228273 1.87492 0 2.42602 0 3.00065Z'
              fill='#A5A2A5'
            />
            <path
              d='M5.8335 3.00065C5.8335 3.57529 6.06177 4.12639 6.4681 4.53272C6.87443 4.93904 7.42553 5.16732 8.00016 5.16732C8.5748 5.16732 9.1259 4.93904 9.53223 4.53272C9.93856 4.12639 10.1668 3.57529 10.1668 3.00065C10.1668 2.42602 9.93856 1.87492 9.53223 1.46859C9.1259 1.06226 8.5748 0.833984 8.00016 0.833984C7.42553 0.833984 6.87443 1.06226 6.4681 1.46859C6.06177 1.87492 5.8335 2.42602 5.8335 3.00065Z'
              fill='#A5A2A5'
            />
            <path
              d='M11.6665 3.00065C11.6665 3.57529 11.8948 4.12639 12.3011 4.53272C12.7074 4.93904 13.2585 5.16732 13.8332 5.16732C14.4078 5.16732 14.9589 4.93904 15.3652 4.53272C15.7716 4.12639 15.9998 3.57529 15.9998 3.00065C15.9998 2.42602 15.7716 1.87492 15.3652 1.46859C14.9589 1.06226 14.4078 0.833984 13.8332 0.833984C13.2585 0.833984 12.7074 1.06226 12.3011 1.46859C11.8948 1.87492 11.6665 2.42602 11.6665 3.00065Z'
              fill='#A5A2A5'
            />
          </svg>
        </IconButton>
      </Box>

      <Menu
        id='basic-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}>
        <MenuItem
          onClick={() => {
            navigate(project.id)
            handleClose()
          }}>
          View
        </MenuItem>
      </Menu>
    </>
  )
}
